module.exports = __webpack_public_path__ + "static/media/f09.6c266f1e.jpg";